// ============================================================================
// Table Columns: Templates
// Key: templates
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
	enumRenderer,
	iconEnumRenderer,
	relationCountRenderer,
} from '../../entity-config-runtime/entity-table-config'
import type {
	CustomPageDto,
	QueueSummary,
	RoleSummary,
	SkillSummary,
	TeamSummary,
	TemplateCustomPageResponse,
	TemplateQueueResponse,
	TemplateRoleResponse,
	TemplateSkillResponse,
	TemplateSummary,
	TemplateTeamResponse,
} from '../api/backstage.schemas'
import {
	ApplicationScope,
	CustomPageIcon,
	EntityScope,
	LinkTarget,
	MediaType,
} from '../api/backstage.schemas'
// #endregion

// #region Entity List Columns
export const templatesListColumnsConfig = {
	columns: [
		'name',
		'description',
		cellRenderer('isDefault', 'boolean'),
		relationCountRenderer('queueCount', 'queues'),
		relationCountRenderer('skillCount', 'skills'),
		relationCountRenderer('roleCount', 'roles'),
		cellRenderer('settingCount', 'number'),
		relationCountRenderer('teamCount', 'teams'),
		relationCountRenderer('customPageCount', 'customPages'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
	actions: [
		{
			type: 'link',
			id: 'id',
			label: 'tables_actions_detail',
			icon: 'ArrowRight',
			style: 'link',
			href: (row: TemplateSummary) => `/templates/${row.id}/details`,
		},
	],
} as const satisfies EntityTableConfig<TemplateSummary>
// #endregion

// #region Relation List Columns
// #region Relation: CustomPages
export const templatesRelationsCustomPagesAssignedColumnsConfig = {
	columns: ['templateName', 'customPageName'],
} as const satisfies EntityTableConfig<TemplateCustomPageResponse>
export const templatesRelationsCustomPagesAvailableColumnsConfig = {
	columns: [
		'displayName',
		'description',
		'url',
		iconEnumRenderer('icon', CustomPageIcon, 'CustomPageIcon'),
		cellRenderer('enabledForAllUsers', 'boolean'),
		cellRenderer('sortOrder', 'number'),
		enumRenderer('linkTarget', LinkTarget, 'LinkTarget'),
		cellRenderer('iFrameWidth', 'number'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
} as const satisfies EntityTableConfig<CustomPageDto>
// #endregion

// #region Relation: Queues
export const templatesRelationsQueuesAssignedColumnsConfig = {
	columns: ['templateName', 'queueName', 'queueDescription'],
} as const satisfies EntityTableConfig<TemplateQueueResponse>
export const templatesRelationsQueuesAvailableColumnsConfig = {
	columns: [
		'name',
		'description',
		cellRenderer('wrapUpTimeSeconds', 'number'),
		cellRenderer('sortOrder', 'number'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
		cellRenderer('userCount', 'number'),
		cellRenderer('contactCodeTreeCount', 'number'),
		enumRenderer('type', MediaType, 'MediaType'),
	],
} as const satisfies EntityTableConfig<QueueSummary>
// #endregion

// #region Relation: Roles
export const templatesRelationsRolesAssignedColumnsConfig = {
	columns: ['templateName', 'roleName'],
} as const satisfies EntityTableConfig<TemplateRoleResponse>
export const templatesRelationsRolesAvailableColumnsConfig = {
	columns: [
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
		'name',
		enumRenderer('entityScope', EntityScope, 'EntityScope'),
		enumRenderer('applicationScope', ApplicationScope, 'ApplicationScope'),
		cellRenderer('isDefault', 'boolean'),
		cellRenderer('isBaseRole', 'boolean'),
		'userGroup',
		cellRenderer('permissionCount', 'number'),
		cellRenderer('userCount', 'number'),
		cellRenderer('templateCount', 'number'),
	],
} as const satisfies EntityTableConfig<RoleSummary>
// #endregion

// #region Relation: Skills
export const templatesRelationsSkillsAssignedColumnsConfig = {
	columns: ['templateName', 'skillName'],
} as const satisfies EntityTableConfig<TemplateSkillResponse>
export const templatesRelationsSkillsAvailableColumnsConfig = {
	columns: [
		'name',
		cellRenderer('userCount', 'number'),
		cellRenderer('teamCount', 'number'),
		cellRenderer('templateCount', 'number'),
		cellRenderer('skillGroupCount', 'number'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
} as const satisfies EntityTableConfig<SkillSummary>
// #endregion

// #region Relation: Teams
export const templatesRelationsTeamsAssignedColumnsConfig = {
	columns: ['templateName', 'teamName'],
} as const satisfies EntityTableConfig<TemplateTeamResponse>
export const templatesRelationsTeamsAvailableColumnsConfig = {
	columns: [
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
		'name',
		cellRenderer('isDefaultTeam', 'boolean'),
		'userGroup',
		'responsibleUserGroup',
		cellRenderer('userCount', 'number'),
		cellRenderer('queueCount', 'number'),
		cellRenderer('skillCount', 'number'),
		cellRenderer('customPageCount', 'number'),
		cellRenderer('skillGroupCount', 'number'),
	],
} as const satisfies EntityTableConfig<TeamSummary>
// #endregion
// #endregion

// #region Columns Config Export
export const templatesColumnsConfig = {
	list: templatesListColumnsConfig,
	relations: {
		customPages: {
			assigned: templatesRelationsCustomPagesAssignedColumnsConfig,
			available: templatesRelationsCustomPagesAvailableColumnsConfig,
		},
		queues: {
			assigned: templatesRelationsQueuesAssignedColumnsConfig,
			available: templatesRelationsQueuesAvailableColumnsConfig,
		},
		roles: {
			assigned: templatesRelationsRolesAssignedColumnsConfig,
			available: templatesRelationsRolesAvailableColumnsConfig,
		},
		skills: {
			assigned: templatesRelationsSkillsAssignedColumnsConfig,
			available: templatesRelationsSkillsAvailableColumnsConfig,
		},
		teams: {
			assigned: templatesRelationsTeamsAssignedColumnsConfig,
			available: templatesRelationsTeamsAvailableColumnsConfig,
		},
	},
} as const
// #endregion
